var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvailable247(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7046 20.2383C16.0913 20.2383 20.4581 15.8716 20.4581 10.4849C20.4581 5.09821 16.0913 0.731445 10.7046 0.731445C5.31794 0.731445 0.951172 5.09821 0.951172 10.4849C0.951172 15.8716 5.31794 20.2383 10.7046 20.2383Z",
    fill: "url(#paint0_linear_4032_2917)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5496 19.6656C11.9529 19.7851 11.3358 19.8477 10.7042 19.8477C5.53639 19.8477 1.34081 15.6521 1.34081 10.4844C1.34081 5.31666 5.53639 1.12109 10.7042 1.12109C15.3619 1.12109 19.2301 4.5293 19.948 8.9859C19.9823 9.19847 20.1826 9.34327 20.3952 9.309C20.6078 9.2748 20.7526 9.07438 20.7184 8.86181C19.9405 4.03366 15.7502 0.34082 10.7042 0.34082C5.10577 0.34082 0.560547 4.88604 0.560547 10.4844C0.560547 16.0828 5.10577 20.628 10.7042 20.628C11.3882 20.628 12.0566 20.5601 12.7028 20.4307C12.9139 20.3884 13.051 20.1827 13.0087 19.9716C12.9665 19.7605 12.7607 19.6233 12.5496 19.6656Z",
    fill: "url(#paint1_linear_4032_2917)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3396 8.92383C18.2607 8.92383 18.1896 8.9713 18.1594 9.04419C18.1292 9.11709 18.1459 9.201 18.2017 9.25683C18.7491 9.8043 19.8165 10.8716 20.196 11.2511C20.2326 11.2877 20.2821 11.3082 20.3339 11.3082C20.3856 11.3082 20.4352 11.2877 20.4718 11.2511C20.8512 10.8716 21.9186 9.8043 22.4661 9.25683C22.5219 9.201 22.5386 9.11709 22.5084 9.04419C22.4782 8.9713 22.4071 8.92383 22.3282 8.92383C21.3866 8.92383 19.2812 8.92383 18.3396 8.92383Z",
    fill: "url(#paint2_linear_4032_2917)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5112 9.4427L8.28932 5.55962C8.18237 5.37276 7.94381 5.30787 7.75694 5.41482C7.57007 5.5217 7.50512 5.76026 7.61207 5.94719L9.83391 9.83027C9.94087 10.0171 10.1794 10.082 10.3663 9.97507C10.5532 9.86819 10.6181 9.62964 10.5112 9.4427Z",
    fill: "url(#paint3_linear_4032_2917)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61533 10.7682L8.00135 12.0302C7.83168 12.1628 7.8017 12.4082 7.93428 12.5778C8.06694 12.7474 8.3123 12.7775 8.48197 12.6449L10.0959 11.383C10.2656 11.2503 10.2957 11.005 10.163 10.8353C10.0304 10.6657 9.78499 10.6357 9.61533 10.7682Z",
    fill: "url(#paint4_linear_4032_2917)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3125 2.42721V4.12349C10.3125 4.3388 10.4873 4.51366 10.7027 4.51366C10.918 4.51366 11.0928 4.3388 11.0928 4.12349V2.42721C11.0928 2.2119 10.918 2.03711 10.7027 2.03711C10.4873 2.03711 10.3125 2.2119 10.3125 2.42721Z",
    fill: "url(#paint5_linear_4032_2917)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33743 3.70142L6.76151 4.4359C6.86917 4.62235 7.108 4.68639 7.29445 4.57867C7.48089 4.47101 7.54494 4.23225 7.43721 4.04573L7.0132 3.31125C6.90554 3.12481 6.66671 3.06083 6.48026 3.16848C6.29375 3.27614 6.22977 3.5149 6.33743 3.70142Z",
    fill: "url(#paint6_linear_4032_2917)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4862 6.1177L16.7517 6.54179C16.5652 6.64944 16.5013 6.88828 16.6089 7.07473C16.7166 7.26118 16.9554 7.32522 17.1418 7.21757L17.8763 6.79348C18.0628 6.68582 18.1268 6.44699 18.0192 6.26054C17.9115 6.07402 17.6727 6.01005 17.4862 6.1177Z",
    fill: "url(#paint7_linear_4032_2917)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53101 6.79348L4.26549 7.21757C4.45201 7.32522 4.69077 7.26118 4.79843 7.07473C4.90608 6.88828 4.84211 6.64944 4.65566 6.54179L3.92118 6.1177C3.73466 6.01005 3.4959 6.07402 3.38824 6.26054C3.28052 6.44699 3.34456 6.68582 3.53101 6.79348Z",
    fill: "url(#paint8_linear_4032_2917)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3943 3.31125L13.9702 4.04573C13.8626 4.23225 13.9266 4.47101 14.113 4.57867C14.2995 4.68639 14.5383 4.62235 14.6459 4.4359L15.07 3.70142C15.1777 3.5149 15.1137 3.27614 14.9272 3.16848C14.7407 3.06083 14.502 3.12481 14.3943 3.31125Z",
    fill: "url(#paint9_linear_4032_2917)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3125 16.8452V18.5415C10.3125 18.7568 10.4873 18.9316 10.7027 18.9316C10.918 18.9316 11.0928 18.7568 11.0928 18.5415V16.8452C11.0928 16.6299 10.918 16.4551 10.7027 16.4551C10.4873 16.4551 10.3125 16.6299 10.3125 16.8452Z",
    fill: "url(#paint10_linear_4032_2917)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26549 13.7515L3.53101 14.1756C3.34456 14.2832 3.28052 14.522 3.38824 14.7085C3.4959 14.895 3.73466 14.9589 3.92118 14.8513L4.65566 14.4273C4.84211 14.3195 4.90608 14.0808 4.79843 13.8943C4.69077 13.7078 4.45201 13.6438 4.26549 13.7515Z",
    fill: "url(#paint11_linear_4032_2917)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76151 16.533L6.33743 17.2675C6.22977 17.4539 6.29375 17.6928 6.48026 17.8004C6.66671 17.9081 6.90554 17.8441 7.0132 17.6576L7.43721 16.9231C7.54494 16.7367 7.48089 16.4978 7.29445 16.3902C7.108 16.2825 6.86917 16.3465 6.76151 16.533Z",
    fill: "url(#paint12_linear_4032_2917)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34223 10.0947H2.64596C2.43065 10.0947 2.25586 10.2696 2.25586 10.4849C2.25586 10.7002 2.43065 10.875 2.64596 10.875H4.34223C4.55754 10.875 4.7324 10.7002 4.7324 10.4849C4.7324 10.2696 4.55754 10.0947 4.34223 10.0947Z",
    fill: "url(#paint13_linear_4032_2917)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8252 14.572C13.8252 14.0385 14.2583 13.6055 14.7917 13.6055C15.3251 13.6055 15.7581 14.0385 15.7581 14.572C15.7581 14.9373 15.5681 15.1875 15.317 15.3904C14.9934 15.6519 14.5753 15.842 14.2055 16.0407C13.9107 16.199 13.6428 16.3637 13.4463 16.5535C13.193 16.7979 13.0449 17.0841 13.0449 17.4359V18.0389C13.0449 18.2543 13.2196 18.429 13.4351 18.429H16.1483C16.3636 18.429 16.5384 18.2542 16.5384 18.0389C16.5384 17.8235 16.3636 17.6487 16.1483 17.6487H13.8252V17.4359C13.8252 17.2579 13.9465 17.1376 14.0967 17.0222C14.3355 16.8387 14.6554 16.6866 14.9738 16.5185C15.7809 16.0925 16.5384 15.5584 16.5384 14.572C16.5384 13.6079 15.7557 12.8252 14.7917 12.8252C13.8276 12.8252 13.0449 13.6079 13.0449 14.572C13.0449 14.7873 13.2197 14.9621 13.4351 14.9621C13.6504 14.9621 13.8252 14.7873 13.8252 14.572Z",
    fill: "url(#paint14_linear_4032_2917)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6777 13.2154V18.0389C19.6777 18.2542 19.8526 18.429 20.0679 18.429C20.2832 18.429 20.4581 18.2542 20.4581 18.0389V13.2154C20.4581 13 20.2832 12.8252 20.0679 12.8252C19.8526 12.8252 19.6777 13 19.6777 13.2154Z",
    fill: "url(#paint15_linear_4032_2917)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5794 13.1208L16.9765 15.5326C16.9474 15.6491 16.9735 15.7726 17.0475 15.8673C17.1214 15.9619 17.2349 16.0173 17.355 16.0173H20.0682C20.2835 16.0173 20.4584 15.8425 20.4584 15.6272C20.4584 15.4119 20.2835 15.2371 20.0682 15.2371H17.8547C17.8547 15.237 18.3364 13.31 18.3364 13.31C18.3886 13.1011 18.2615 12.8892 18.0525 12.8369C17.8436 12.7847 17.6316 12.9119 17.5794 13.1208Z",
    fill: "url(#paint16_linear_4032_2917)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7047 11.5169C11.2752 11.5169 11.7376 11.0545 11.7376 10.484C11.7376 9.9136 11.2752 9.45117 10.7047 9.45117C10.1343 9.45117 9.67188 9.9136 9.67188 10.484C9.67188 11.0545 10.1343 11.5169 10.7047 11.5169Z",
    fill: "url(#paint17_linear_4032_2917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4032_2917",
    x1: 5.50777,
    y1: 2.00441,
    x2: 17.3151,
    y2: 18.1895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4032_2917",
    x1: 3.72347,
    y1: 2.95662,
    x2: 21.0858,
    y2: 19.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DD2C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CAFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4032_2917",
    x1: 19.1013,
    y1: 7.69118,
    x2: 21.5665,
    y2: 10.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DD2C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CAFA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4032_2917",
    x1: 3.72266,
    y1: 2.95681,
    x2: 21.085,
    y2: 19.3446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C6484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C3D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4032_2917",
    x1: 3.72311,
    y1: 2.95631,
    x2: 21.0853,
    y2: 19.3441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C6484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C3D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4032_2917",
    x1: 4.46055,
    y1: 3.85207,
    x2: 16.945,
    y2: 15.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4032_2917",
    x1: 4.46173,
    y1: 3.8517,
    x2: 16.9461,
    y2: 15.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4032_2917",
    x1: 4.46151,
    y1: 3.85182,
    x2: 16.946,
    y2: 15.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4032_2917",
    x1: 4.46163,
    y1: 3.85182,
    x2: 16.9461,
    y2: 15.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4032_2917",
    x1: 4.46153,
    y1: 3.8517,
    x2: 16.9459,
    y2: 15.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4032_2917",
    x1: 4.46055,
    y1: 3.85182,
    x2: 16.945,
    y2: 15.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4032_2917",
    x1: 4.46163,
    y1: 3.85253,
    x2: 16.946,
    y2: 15.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4032_2917",
    x1: 4.46173,
    y1: 3.85224,
    x2: 16.9463,
    y2: 15.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4032_2917",
    x1: 4.46098,
    y1: 3.85254,
    x2: 16.9453,
    y2: 15.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4032_2917",
    x1: 3.72342,
    y1: 2.95661,
    x2: 21.0857,
    y2: 19.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C6484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C3D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4032_2917",
    x1: 3.72435,
    y1: 2.95661,
    x2: 21.0866,
    y2: 19.3439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C6484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C3D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4032_2917",
    x1: 3.72433,
    y1: 2.95666,
    x2: 21.0867,
    y2: 19.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C6484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C3D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4032_2917",
    x1: 9.67188,
    y1: 10.484,
    x2: 11.7376,
    y2: 10.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DD2C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CAFA0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailable247);
export default __webpack_public_path__ + "static/media/Available247.3f5112aa940a98a3e4fd7e96d7a5cae3.svg";
export { ForwardRef as ReactComponent };